<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('disciplinaryAction.pageTitle') }}
      </h1>
      <ts-breadcrumb
        :items="[
          { text: $t('toHomePage'), href: '/' },
          {
            text: $t('disciplinaryAction.pageTitle'),
            href: '/disciplinary'
          },
          {
            text: $t('disciplinaryAction.create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-loading-banner :loading="ready_fetch">
      <div class="row">
        <div class="col-md-12">
          <ts-card>
            <ts-card-wrapper>
              <div class="row">
                <div class="col-md-6">
                  <label class="required">{{
                    $t('disciplinaryAction.date')
                  }}</label>
                  <ts-date-picker-input v-model="model.dis_date">
                  </ts-date-picker-input>
                  <div class="validate" v-if="errors.has('dis_date')">
                    {{ errors.first('dis_date') }}
                  </div>
                  <label class="required mt-3">{{
                    $t('disciplinaryAction.branchName')
                  }}</label>
                  <a-select
                    style="width: 100%"
                    v-model.number="model.branch_id"
                    :options="branches"
                    :show-search="true"
                    :filter-option="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                  >
                  </a-select>
                  <div class="validate" v-if="errors.has('branch_id')">
                    {{ errors.first('branch_id') }}
                  </div>
                  <label class="required mt-3">{{
                    $t('disciplinaryAction.mainProgram')
                  }}</label>
                  <a-select
                    style="width: 100%"
                    v-model.number="model.acp_id"
                    :options="main_programs"
                    :show-search="true"
                    :filter-option="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="onMainProgramChange"
                  ></a-select>
                  <div class="validate" v-if="errors.has('acp_id')">
                    {{ errors.first('acp_id') }}
                  </div>
                  <label class="required mt-3">{{
                    $t('disciplinaryAction.subProgram')
                  }}</label>
                  <a-select
                    style="width: 100%"
                    v-model.number="model.acps_id"
                    :options="sub_programs"
                    :show-search="true"
                    :filter-option="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="onSubChange"
                    :disabled="!model.acp_id"
                  ></a-select>
                  <div class="validate" v-if="errors.has('acps_id')">
                    {{ errors.first('acps_id') }}
                  </div>
                  <label class="required mt-3">{{
                    $t('disciplinaryAction.academicYear')
                  }}</label>
                  <a-select
                    style="width: 100%"
                    v-model.number="model.ac_year_id"
                    :options="ac_year_list"
                    :loading="fetching_academic_year"
                    @change="acYearChange"
                  ></a-select>
                  <div class="validate" v-if="errors.has('ac_year_id')">
                    {{ errors.first('ac_year_id') }}
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="required">{{
                    $t('disciplinaryAction.academicTerm')
                  }}</label>
                  <a-select
                    style="width: 100%"
                    v-model.number="model.ac_term_id"
                    :options="ac_terms"
                    :show-search="true"
                    :loading="fetching_academic_term"
                    :filter-option="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    @change="acTermChange"
                  ></a-select>
                  <div class="validate" v-if="errors.has('ac_term_id')">
                    {{ errors.first('ac_term_id') }}
                  </div>
                  <label class="required mt-3">{{
                    $t('disciplinaryAction.className')
                  }}</label>
                  <a-select
                    style="width: 100%"
                    v-model="model.class_id"
                    :options="class_options"
                    :show-search="true"
                    :loading="fetching_class_operation"
                    :filter-option="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    mode="multiple"
                    :max-tag-count="5"
                    :max-tag-text-length="50"
                    @change="classChange"
                  ></a-select>
                  <div class="validate" v-if="errors.has('class_id')">
                    {{ errors.first('class_id') }}
                  </div>
                  <label class="mt-3 required">{{
                    $t('disciplinaryAction.studentName')
                  }}</label>
                  <a-select
                    style="width: 100%"
                    v-model="model.student_id"
                    :options="student_profile"
                    :show-search="true"
                    :loading="fetching_student_profile"
                    :filter-option="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    mode="multiple"
                    :max-tag-count="5"
                    :max-tag-text-length="50"
                  ></a-select>
                  <label class="mt-3 required">{{
                    $t('disciplinaryAction.subjectType')
                  }}</label>
                  <a-select
                    class="ts-mb-4"
                    style="width: 100%"
                    v-model="model.action_type_id"
                    :options="subjectTypes"
                    :show-search="true"
                    :loading="fetching_student_profile"
                    :filter-option="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                  >
                  </a-select>
                  <div
                    class="validate"
                    v-if="errors.has('disciplinary_subject_id')"
                  >
                    {{ errors.first('disciplinary_subject_id') }}
                  </div>
                  <div v-show="model.action_type_id == 1">
                    <label class="required">{{
                      $t('disciplinaryAction.subject')
                    }}</label>
                    <a-select
                      v-model="model.disciplinary_subject_id"
                      style="width: 100%"
                      :options="disciplinarySubjects"
                      :show-search="true"
                      option-filter-prop="children"
                      :filter-option="
                        (input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      "
                    ></a-select>
                    <div
                      class="validate"
                      v-if="errors.has('disciplinary_subject_id')"
                    >
                      {{ errors.first('disciplinary_subject_id') }}
                    </div>
                  </div>
                  <div v-show="model.action_type_id == 2">
                    <label class="required">{{
                      $t('disciplinaryAction.appreciationSubject')
                    }}</label>
                    <a-select
                      style="width: 100%"
                      v-model="model.disciplinary_subject_id"
                      :options="appreciationSubjects"
                      :show-search="true"
                      :filter-option="
                        (input, option) =>
                          option.componentOptions.children[0].text
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                      "
                      mode="multiple"
                      :max-tag-count="5"
                      :max-tag-text-length="50"
                    ></a-select>
                    <div
                      class="validate"
                      v-if="errors.has('disciplinary_subject_id')"
                    >
                      {{ errors.first('disciplinary_subject_id') }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="row ts-mt-6">
                <div class="col-md-12 text-right">
                  <ts-button
                    class="ts-mr-2"
                    @click.prevent="$router.push({ name: 'disciplinary' })"
                  >
                    {{ $t('cancel') }}
                  </ts-button>
                  <ts-button
                    color="primary"
                    :waiting="waiting"
                    @click.prevent="save"
                    >{{ $t('save') }}</ts-button
                  >
                </div>
              </div>
            </ts-card-wrapper>
          </ts-card>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
export default {
  name: 'disciplinary-create',
  data() {
    return {
      loading: false,
      waiting: false,
      fetching_academic_year: false,
      fetching_academic_term: false,
      fetching_class_operation: false,
      fetching_student_profile: false,
      branches: [],
      disciplinarySubjects: [],
      appreciationSubjects: [],
      ac_year_list: [],
      main_programs: [],
      sub_programs: [],
      ac_terms: [],
      subjectTypes: [],
      class_options: [],
      student_profile: [],
      errors: new Errors(),
      ready_fetch: false,
      model: {
        disciplinary_id: 0,
        disciplinary_subject_id: undefined,
        ac_year_id: null,
        ac_term_id: null,
        acp_id: null,
        acps_id: null,
        action_type_id: null,
        class_id: [],
        student_id: undefined,
        branch_id: null,
        dis_date: moment().format('DD-MM-YYYY')
      }
    }
  },
  computed: {
    acStatusId: {
      get() {
        return this.$store.state.disciplinaryAction.ac_status_id
      },
      set(newValue) {
        this.$store.commit('disciplinaryAction/SET_AC_STATUS', newValue)
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    ...mapActions('reportAcademic', [
      'getBranch',
      'getYear',
      'getMainProgram',
      'getSubProgram',
      'getTerm',
      'getClass',
      'getStudentPofile'
    ]),
    // Fetch Data
    async fetchData() {
      this.loading = true
      await this.getBranch().then(response => {
        this.branches = response.data.map(el => ({
          value: el.branch_id,
          label: el.branch_name_en
        }))
      })
      await this.$store
        .dispatch('disciplinaryAction/getDisciplinarySubject')
        .then(response => {
          this.disciplinarySubjects = response.data
            .filter(el => el.dis_status !== 'Appreciation')
            .map(el => ({
              value: el.id,
              label: el.subject_name
            }))
          this.appreciationSubjects = response.data
            .filter(el => el.dis_status == 'Appreciation')
            .map(el => ({
              value: el.id,
              label: el.subject_name
            }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.$store
        .dispatch('disciplinaryAction/getSubjectType')
        .then(response => {
          this.subjectTypes = response.data.map(el => ({
            value: el.id,
            label: el.subject_type_name
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
      await this.getMainProgram()
        .then(response => {
          this.main_programs = response.data.map(el => ({
            value: el.acp_id,
            label: el.acp_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
          this.model.branch_id = +this.$store.state.authUser.default_branch_id
        })
    },
    //onChange branch
    onBranchChange() {
      this.model.ac_year_id = null
      this.model.acps_id = null
      this.model.ac_term_id = null
      this.fetching_academic_year = true
      this.getYear({
        filter: {
          ac_status_id: '1,3',
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
            el => ({
              value: el.ac_year_id,
              label:
                el.ac_year +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : ' ( Next ) ')
            })
          )
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_academic_year = false
        })
    },
    //onMainProgramChange
    async onMainProgramChange(acp_id) {
      this.model.acps_id = null
      await this.getSubProgram({
        filter: {
          acp_id: acp_id
        }
      })
        .then(response => {
          this.sub_programs = response.data.map(el => ({
            value: el.acps_id,
            label: el.acps_name_foreign,
            scoring_cyles: el.scoring_cyles.map(el => el.scoring_cycle_id)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    //onSubChange
    onSubChange(acps_id) {
      this.model.ac_term_id = null
      this.model.class_id = []
      if (this.model.ac_year_id) {
        this.fetching_academic_term = true
        this.getTerm({
          filter: {
            acps_id: acps_id,
            ac_status_id: '1,3',
            ac_year_id: this.model.ac_year_id,
            branch_id: this.model.branch_id
          },
          branch_id: [this.model.branch_id]
        })
          .then(response => {
            this.ac_terms = response.data.map(el => ({
              value: el.ac_term_id,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : '( Next )')
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetching_academic_term = false
          })
      }
    },
    //acYearChange
    acYearChange() {
      this.model.ac_term_id = null
      this.model.class_id = []
      this.fetching_academic_term = true
      this.getTerm({
        filter: {
          acps_id: this.model.acps_id,
          ac_status_id: '1,3',
          ac_year_id: this.model.ac_year_id,
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            term_order: el.term_order,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                ? ' ( History ) '
                : '( Next )')
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_academic_term = false
        })
    },
    //acTermChange
    acTermChange(ac_term_id) {
      this.fetching_class_operation = true
      this.model.class_id = []
      this.getClass({
        filter: {
          ac_term_id: ac_term_id,
          branch_id: this.model.branch_id
        },
        branch_id: [this.model.branch_id]
      })
        .then(response => {
          this.class_options = response.data.map(el => ({
            value: el.class_id,
            label:
              el.class_name +
              ' | ' +
              el.teacher.full_name_en +
              ' | ' +
              el.academic_study_time.study_time,
            grade_id: el.grade_id
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_class_operation = false
        })
    },
    classChange() {
      this.fetching_student_profile = true
      this.model.student_id = undefined
      this.getStudentPofile({
        filter: {
          student_in_class: this.model.class_id
        }
      })
        .then(response => {
          this.student_profile = response.data.map(el => ({
            value: el.student_id,
            label: el.full_name_en
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.fetching_student_profile = false
        })
    },
    fetchClass() {
      this.loading = true
      this.getClassOperation({
        branch_id: this.$store.state.authUser.default_branch_id
      })
        .then(response => {
          this.class_list = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onClassChange(value, option) {
      this.model.ac_year_id = option.data.props.ac_year_id
      this.model.ac_term_id = option.data.props.term_id
    },
    save() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('disciplinaryAction/store', this.model)
        .then(response => {
          this.clearForm()
          this.waiting = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'disciplinary' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    clearForm() {
      this.model.dis_date = ''
      this.model.branch_id = ''
      this.model.acp_id = ''
      this.model.acps_id = ''
      this.model.ac_year_id = ''
      this.model.ac_term_id = ''
      this.model.class_id = ''
      this.model.student_id = ''
      this.model.disciplinary_subject_id = ''
    }
  },
  watch: {
    'model.branch_id': function(val) {
      if (val) {
        this.onBranchChange()
      }
    }
  }
}
</script>
